import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Scale } from "lucide-react";

const WHATSAPP = "5566999584198";

// Para adicionar uma lei, inclua um item aqui: { numero, titulo, resumo, link }
const LEIS = [];

const LeisSorrisoPage = () => (
  <div className="min-h-screen bg-[#050505] text-[#E7E3EC]">
    <div className="max-w-3xl mx-auto p-6">
      <Link to="/" className="inline-flex items-center gap-2 text-[#E2B84A] mb-6 text-sm font-bold">
        <ArrowLeft size={18} /> Voltar
      </Link>
      <div className="flex items-center gap-3 mb-2">
        <Scale className="w-8 h-8 text-[#E2B84A]" />
        <h1 className="text-4xl font-black text-white">Leis de Sorriso</h1>
      </div>
      <p className="text-[#A19BAA] text-sm mb-8">
        Regras municipais para quem anda de scooter, patinete e bicicleta elétrica em Sorriso-MT.
      </p>
      {LEIS.length === 0 ? (
        <div className="bg-[#E2B84A]/10 border border-[#E2B84A]/40 rounded-lg p-6">
          <p className="text-[#E2B84A] font-black text-lg mb-2">Em breve</p>
          <p className="text-sm leading-relaxed">
            Estamos reunindo a legislação municipal de Sorriso. Assim que estiver pronta, ela aparece aqui, com o resumo de cada lei e o link oficial.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {LEIS.map((l) => (
            <div key={l.numero} className="bg-[#120E1A] border border-[#2D243F] rounded-lg p-5">
              <p className="text-[#E2B84A] text-xs font-bold mb-1">{l.numero}</p>
              <h2 className="text-white font-black text-lg mb-2">{l.titulo}</h2>
              <p className="text-sm leading-relaxed mb-3">{l.resumo}</p>
              {l.link && (
                <a href={l.link} target="_blank" rel="noreferrer" className="text-[#E2B84A] text-sm font-bold">
                  Ver texto oficial
                </a>
              )}
            </div>
          ))}
        </div>
      )}
      <p className="text-[#716A80] text-xs mt-8 leading-relaxed">
        Este resumo é informativo e não substitui o texto oficial publicado pela Prefeitura ou pela Câmara Municipal. Em caso de dúvida, consulte a fonte oficial.
      </p>
      <a
        href={"https://wa.me/" + WHATSAPP}
        target="_blank"
        rel="noreferrer"
        className="inline-block mt-6 bg-[#E2B84A] text-black font-bold rounded-lg px-6 py-3 text-sm"
      >
        Falar com a Giraia pelo WhatsApp
      </a>
    </div>
  </div>
);

export default LeisSorrisoPage;
